<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <template v-if="wasVerificationLinkSent">
      <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
        <h2
          class="cf-title cf-title--2"
        >
          {{ signInVerficationContent.title }}
        </h2>

        <p class="cf-subtitle cf-subtitle--2">
          {{ signInVerficationContent.linkSentTo }}
        </p>

        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
          {{ signInInfo }}
        </p>

        <p class="cf-subtitle cf-subtitle--2">
          {{ signInVerficationContent.verificationInstructions }}
        </p>

        <p class="cf-subtitle cf-subtitle--2">
          Didn't receive the passcode?

          <span
            class="cf-link cf-link--brand-secondary cf-link--heavy"
            @click="getVerificationLinkHandler"
          >
            Resend It
          </span>
        </p>
      </div>
    </template>

    <template v-else>
      <div class="cf-flex cf-flex--column cf-flex--gap-16">

        <!-- TODO: Implement functionality from Sign In Modal -->
        <!-- <cf-info-banner
        v-if="isGiftedPointsClaim"
        :message="giftedPointsClaimInfoContent"
        icon="cf-icon far fa-gift"
        /> -->

        <!-- TODO: Implement functionality from Sign In Modal -->
        <!-- <cf-info-banner
        v-if="isPromoClaim"
        :message="promoClaimInfoContent"
        icon="cf-icon far fa-gift"
        /> -->

        <!-- TODO: Implement functionality from Sign In Modal -->
        <!-- <img
        v-if="signInContent.imageUrl"
        class="cf-image cf-image--center cf-image--logo"
        :alt="merchant.name"
        :src="signInContent.imageUrl"
        onerror="this.src='/images/image-not-found.png';"
        > -->

        <h2
          v-if="signInContent.title"
          class="cf-title cf-title--2"
        >
          {{ signInContent.title }}
        </h2>

        <p
          v-if="signInContent.description"
          class="cf-subtitle cf-subtitle--2"
        >
          {{ signInContent.description }}
        </p>

        <p
          v-if="sessionExpired"
          class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy"
        >
          Your session has expired. Please sign in to continue.
        </p>
      </div>

      <div
        v-if="isPhoneOrEmailSignOn"
        class="cf-tabs"
      >
        <button
          :class="['cf-tab', { 'cf-tab--active': isEmailSignIn }]"
          type="button"
          @click="setSignInMethodHandler('email')"
        >
          Email Address
        </button>

        <button
          :class="['cf-tab', { 'cf-tab--active': isPhoneNumberSignIn }]"
          type="button"
          @click="setSignInMethodHandler('phone')"
        >
          Phone Number
        </button>
      </div>

      <cf-validated-form
        name="signInForm"
        @valid-submit="getVerificationLinkHandler"
      >
        <div class="cf-flex cf-flex--column cf-flex--gap-16">
          <transition
            mode="out-in"
            :name="isPhoneNumberSignIn ? 'slide-to-right-fast' : 'slide-to-left-fast'"
          >
            <cf-phone-number-input
              v-if="isPhoneNumberSignIn"
              key="phone"
              v-model="phoneNumber"
              label="Phone Number"
              name="phoneNumberSignIn"
              :validations="{ required: true }"
            />

            <cf-text-input
              v-else
              key="email"
              v-model="email"
              type="email"
              label="Email"
              name="emailSignIn"
              :validations="{ required: true }"
            />
          </transition>

          <p
            class="cf-subtitle cf-subtitle--2 cf-text-align-left cf-content"
            v-html="signInContent.ssoTerms"
          />

          <button
            class="cf-button cf-button--primary cf-button--lg cf-button--fill"
            type="submit"
          >
            {{ signInContent.buttonCta }}
          </button>
        </div>
      </cf-validated-form>

      <div class="cf-modal__footer">
        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--black">
          Don't have an account?

          <button
            class="cf-link cf-link--brand-secondary cf-link--heavy"
            type="button"
            @click="openSignUpModalHandler"
          >
            Create Account
          </button>
        </p>
      </div>
    </template>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';
  import events from '@/services/events';

  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
  import CfPhoneNumberInput from '@/view/components/shared/cf-phone-number-input/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'SingleSignOn',

    components: {
      CfValidatedForm,
      CfPhoneNumberInput,
      CfTextInput
    },

    props: {
      sessionExpired: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        email: null,
        isSigningIn: false,
        password: null,
        phoneNumber: null,
        signInMethod: 'email',
        wasVerificationLinkSent: false
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['loyaltyOptions']),
      ...mapGetters('session', ['currentUser', 'session']),
      ...mapGetters('offers', ['offers']),

      signInContent() {
        const { title, description, metadata } = this.content.ThirdPartyLoyaltyLogin;

        const { buttonCta, loyaltyPrivacyPolicyAndTermsOfService: ssoTerms } = metadata;

        return { title, description, buttonCta, ssoTerms };
      },

      signInVerficationContent() {
        const { title, metadata } = this.content.ThirdPartyLoyaltyVerify;

        const { linkSentTo, emailInstructions, phoneInstructions } = metadata;

        const verificationInstructions = this.signInMethod === 'phone'
          ? phoneInstructions
          : emailInstructions;

        return { title, linkSentTo, verificationInstructions };
      },

      isGiftedPointsClaim() {
        return !!this.offers.giftingPoints.pointGiftClaimCode;
      },

      giftedPointsClaimInfoContent() {
        const pointsCurrency = this.offers.giftingPoints.currencyPluralName;

        return `Sign in to claim your ${pointsCurrency}!`;
      },

      /** TODO: Implement functionality from Sign In Modal */
      //   isPromoClaim() {
      //     return !!this.offers.promoCode.claimCode;
      //   },

      /** TODO: Implement functionality from Sign In Modal */
      //   promoClaimInfoContent() {
      //     return 'Sign in to claim your reward!';
      //   },

      isPhoneOrEmailSignOn() {
        return this.loyaltyOptions.loyaltySsoUsernameType === 'EmailAndPhone';
      },

      isPhoneNumberSignIn() {
        return this.signInMethod === 'phone';
      },

      isEmailSignIn() {
        return this.signInMethod === 'email';
      },

      signInInfo() {
        return this.isEmailSignIn ? this.email : this.phoneNumber;
      }
    },

    mounted() {
      this.onComponentMounted();
    /** TODO: Implement functionality from Sign In Modal */
    //   if (this.offers.giftingPoints.pointGiftClaimCode) {
    //     this.$store.commit('offers/SET_GIFTING_POINTS_DATA', { claimGiftedPointsFlow: 'SIGNED_IN' });
    //   }
    },

    methods: {
      onComponentMounted() {
        const loyaltySsoUsernameType = this.loyaltyOptions.loyaltySsoUsernameType.toLowerCase();
        // This type can come back as Email, Phone, or EmailAndPhone -- if it's EmailAndPhone we want to set the
        // signInMethod to the default of 'email' otherwise just use the type as is which is either 'email' or 'phone'
        this.signInMethod = loyaltySsoUsernameType === 'emailandphone' ? 'email' : loyaltySsoUsernameType;
      },

      setSignInMethodHandler(method) {
        this.signInMethod = method;
      },

      async getVerificationLinkHandler() {
        try {
          const contactInfo = this.isEmailSignIn ? this.email : this.phoneNumber;

          const dispatchPayload = { contactInfo };

          await this.$store.dispatch('session/signInViaSSO', dispatchPayload);

          this.wasVerificationLinkSent = true;

          events.emit('notification', {
            type: 'success',
            message: 'Your verification link has been sent.'
          });
        }
        catch (error) {
          errorHandlers.generic(error);
        }
      },

      openSignUpModalHandler() {
        this.$openModal('createAccount');

        this.$closeModal('single-sign-on-modal');
      },

      async checkForRetroClaims() {
        const { receiptToken } = this.$route.params;

        const retroClaimReceipt = this.offers.retroReceiptToken;

        if (receiptToken || retroClaimReceipt) {
          const dispatchBody = { type: 'cfReceiptToken', value: receiptToken || retroClaimReceipt };

          await this.$store.dispatch('offers/claimPreviousOrder', dispatchBody);
        }
      }
    }
  };
</script>
